import { lowerCase, snakeCase } from "lodash";
import pluralize from "pluralize";

export const declassifyResource = (resource: string) =>
  pluralize(snakeCase(resource));
